export default __webpack_public_path__ + "static/media/itemImage.4bb2c70d.png";